export default __webpack_public_path__ + "static/media/bottom-bg.c619ba31.jpg";